import { render, staticRenderFns } from "./ParentMenu.vue?vue&type=template&id=99a4283e&scoped=true"
import script from "./ParentMenu.vue?vue&type=script&lang=ts"
export * from "./ParentMenu.vue?vue&type=script&lang=ts"
import style0 from "./ParentMenu.vue?vue&type=style&index=0&id=99a4283e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a4283e",
  null
  
)

export default component.exports